import { useMemo } from 'react';
import { defaultChartLayout, defaultChartOptions, legacyChartLayout } from '../constants';
import { useDeviceTimeSeriesAnnotation } from './useDeviceTimeSeriesAnnotation';
import { useDeviceTimeSeriesDataLabels } from './useDeviceTimeSeriesDataLabels';
import { useDeviceTimeSeriesMarker } from './useDeviceTimeSeriesMarker';
import { useDeviceTimeSeriesScales } from './useDeviceTimeSeriesScales';
import { useDeviceTimeSeriesZoom } from './useDeviceTimeSeriesZoom';

function useDeviceTimeSeriesOptions(props) {
  const { displayAxisTitle, onResize } = props;
  const scales = useDeviceTimeSeriesScales(props);
  const annotation = useDeviceTimeSeriesAnnotation(props);
  const dataLabels = useDeviceTimeSeriesDataLabels(props);
  const marker = useDeviceTimeSeriesMarker(props);
  const zoom = useDeviceTimeSeriesZoom(props);

  return useMemo(
    () => ({
      ...defaultChartOptions,
      events: ['mousedown', 'mouseup', 'mousemove', 'mouseout'],
      scales,
      layout: displayAxisTitle ? defaultChartLayout : legacyChartLayout,
      plugins: {
        ...defaultChartOptions.plugins,
        annotation,
        datalabels: dataLabels,
        marker,
        zoom
      },
      onResize
    }),
    [scales, annotation, dataLabels, marker, zoom, displayAxisTitle, onResize]
  );
}

export { useDeviceTimeSeriesOptions };
